// Wskaznik stanu zapisu pojedynczego pola formularza (4 stany).

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress, Tooltip } from '@mui/material';
import { Check, X } from 'react-bootstrap-icons';
import classnames from 'classnames';

import type { FieldSaveStatus } from 'hooks/usePartialSettingsSave';

import styles from 'theme/components/wise/WiseFieldSaveIndicator/WiseFieldSaveIndicator.module.scss';

interface IWiseFieldSaveIndicatorProps {
  status: FieldSaveStatus;
  className?: string;
}

const WiseFieldSaveIndicator: FC<IWiseFieldSaveIndicatorProps> = ({ status, className }) => {
  const { t } = useTranslation();

  if (status === 'idle') {
    return null;
  }

  const wrapperClass = classnames(styles.componentWrapper, className);

  if (status === 'saving') {
    return (
      <Tooltip title={t('panelSetup.fieldSave.saving') as string} arrow>
        <span className={classnames(wrapperClass, styles.saving)}>
          <CircularProgress size={12} thickness={5} />
        </span>
      </Tooltip>
    );
  }

  if (status === 'saved') {
    return (
      <Tooltip title={t('panelSetup.fieldSave.saved') as string} arrow>
        <span className={classnames(wrapperClass, styles.saved)} aria-label="saved">
          <Check size={16} />
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t('panelSetup.fieldSave.error') as string} arrow>
      <span className={classnames(wrapperClass, styles.error)} aria-label="error">
        <X size={16} />
      </span>
    </Tooltip>
  );
};

export default WiseFieldSaveIndicator;
